

    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <i class="flaticon-cancel-12 close" (click)="cancel()"></i>
                <div class="add-contact-box">
                    <div class="add-contact-content">
                        <h5 class="text-center mb-4">{{ 'edituser' | translate }}</h5>
                        <form style="display: flex; flex-direction: column; gap: 20px;">
                            <div class="row">
                                <div class="col-md-12" style="margin-top: 20px;">
                                    <div class="contact-name">
                                        <i class="las la-user"></i>
                                        <input [(ngModel)]="user.name" type="text" name="name" id="c-name" class="form-control" placeholder="Full name">
                                    </div>
                                </div>
                                <div class="col-md-12" style="margin-top: 20px;">
                                    <div class="contact-name">
                                        <i class="las la-user"></i>
                                        <input [(ngModel)]="user.userName" (change)="changeUserName()" type="text" name="userName" id="c-name" class="form-control" placeholder="Name">
                                        <div class="error-field" *ngIf="duplicateUserNameError">
                                          <span>{{ 'userNameTaken' | translate }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12" style="margin-top: 20px;">
                                    <div class="contact-email">
                                        <i class="las la-envelope"></i>
                                        <input [(ngModel)]="user.email" (change)="changeEmail()" type="text" name="email" id="c-email" class="form-control" placeholder="Email">
                                        <div class="error-field" *ngIf="duplicateEmailError">
                                          <span>{{ 'emailTaken' | translate }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="contact-contact">
                                        <i class="las la-phone"></i>
                                        <input [(ngModel)]="user.phone" name="contact" type="text" id="c-contact" class="form-control" placeholder="Contact">
                                    </div>
                                </div>
                                <div *ngIf="!isMicrosoftAccount" class="col-md-6" style="padding: 0; display: flex">
                                    <button (click)="resetUserPassword()" style=" padding: 6px 5px; width: 92%;" name="resetPassword" class="btn btn-secondary">{{ 'resetPasswordTitle' | translate }}</button>
                                </div>
                            </div>
                            <div class="row" *ngIf="isSuperAdmin || isCompanyAdmin">
                                <div class="col-md-12">
                                    <div class="contact-location">
                                        <i class="las la-map-marker"></i>
                                        <ng-select class="selectpicker" name="profile" [closeOnSelect]="true" placeholder="Perfil" [(ngModel)]="this.user['idRolUser']">
                                            <ng-option
                                            *ngFor="let role of roles"
                                            [value]="role.id"
                                            >
                                            {{ 'roles.' + role.name | translate }}
                                            </ng-option>
                                        </ng-select>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="isCompanyAdmin || isSuperAdmin">
                                <div class="col-md-12">
                                    <div class="contact-location">
                                        <i class="las la-map-marker"></i>
                                        <ng-select class="selectpicker" name="companies" [items]="companies" bindLabel="name" bindValue="id" (ngModelChange)="companyChanged($event)" [closeOnSelect]="true" placeholder="Compañia" [(ngModel)]="this.user['idCompany']"></ng-select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="contact-location">
                                        <i class="las la-map-marker"></i>
                                        <ng-select class="selectpicker" name="departments" [items]="departments" [closeOnSelect]="true" placeholder="Departamento" [(ngModel)]="this.user['department']"></ng-select>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <a class="pointer text-primary font-12 mr-3" (click)="cancel()">{{ 'cancel' | translate }}</a>
                <button class="btn btn-sm btn-primary" (click)="save()" *ngIf="!isLoading">
                  <span>
                    {{ 'submit' | translate }}
                  </span>
                </button>
                <button class="btn btn-sm btn-prim btn-loading" style="min-width: 140px;" *ngIf="isLoading">
                  <span *ngIf="isLoading" class="loader-btn"></span>
                </button>
            </div>
        </div>
    </div>
